let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ky9Yp")).then(() => parcelRequire('dtpha'));